import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../../lib/api";

const catLink = (slug) =>
  slug.startsWith("badge:") ? `/shop?badge=${slug.split(":")[1]}` : `/shop?category=${slug}`;

export const Categories = () => (
  <section className="pt-10 sm:pt-14 pb-4 sm:pb-6" data-testid="categories-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Curated for you</p>
      <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3">Shop by Category</h2>
    </div>

    <div className="mt-7 px-2 sm:px-3">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
        {CATEGORIES.map((c) => (
          <Link
            key={c.slug}
            to={catLink(c.slug)}
            data-testid={`category-card-${c.slug.replace(":", "-")}`}
            className="group relative aspect-[3/4] overflow-hidden bg-surface"
          >
            <img
              src={c.img}
              alt={`${c.name} — buy authentic Ilkal sarees online from Karnataka`}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5">
              <p className="font-heading text-base sm:text-xl text-ivory leading-snug">{c.name}</p>
              <p className="text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-gold mt-1.5 sm:mt-2 group-hover:tracking-[0.3em] transition-all">Shop Now</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);